import { StytchB2B } from "@stytch/react/b2b";
import { B2BProducts, StytchB2BUIConfig } from "@stytch/vanilla-js";

export const DefaultStytchLogin = () => {
  // Check if there's a saved redirect path to include in the redirect URL
  const savedRedirectPath = sessionStorage.getItem('redirectAfterLogin');
  const baseRedirectURL = process.env.REACT_APP_LOGIN_REDIRECT_URL || window.location.origin;
  
  // Also check if we're on the authenticate page and have a redirect param in the URL
  // This handles the case where we're coming back from a magic link
  const urlParams = new URLSearchParams(window.location.search);
  const urlRedirectParam = urlParams.get('redirect');
  
  // If we have a redirect param in the URL and no saved path, save it to sessionStorage
  // This ensures the redirect is preserved when coming back from magic link auth
  if (urlRedirectParam && !savedRedirectPath) {
    sessionStorage.setItem('redirectAfterLogin', urlRedirectParam);
  }
  
  // Create redirect URL with the saved path as a query parameter if it exists
  const getRedirectURL = () => {
    const redirectPath = savedRedirectPath || urlRedirectParam;
    if (!redirectPath) return baseRedirectURL;
    
    try {
      const url = new URL(baseRedirectURL);
      url.searchParams.set('redirect', redirectPath);
      return url.toString();
    } catch {
      return baseRedirectURL;
    }
  };
  
  const redirectURL = getRedirectURL();

  const config: StytchB2BUIConfig = {
    products: [B2BProducts.emailMagicLinks, B2BProducts.passwords],
    authFlowType: "Discovery",
    organizationSlug: "lighthouselabs",
    sessionOptions: {
      sessionDurationMinutes: 60,
    },
    emailMagicLinksOptions: {
      loginRedirectURL: redirectURL,
      signupRedirectURL: redirectURL,
    },
    passwordOptions: {
      loginRedirectURL: redirectURL,
    }
  } as any;

  const styles = {
    container: {
      backgroundColor: "#FFFFFF",
      borderColor: "#ADBCC5",
      borderRadius: "8px",
      width: "400px",
    },
    colors: {
      primary: "#19303D",
      secondary: "#5C727D",
      success: "#0C5A56",
      error: "#8B1214",
    },
    buttons: {
      primary: {
        backgroundColor: "#19303D",
        textColor: "#FFFFFF",
        borderColor: "#19303D",
        borderRadius: "4px",
      },
      secondary: {
        backgroundColor: "#FFFFFF",
        textColor: "#19303D",
        borderColor: "#19303D",
        borderRadius: "4px",
      },
    },
    fontFamily: "Arial",
    hideHeaderText: false,
    logo: {
      logoImageUrl: "",
    },
  };

  return (
    <div className="flex flex-col justify-center items-center mt-8">
      <StytchB2B config={config} styles={styles} />
    </div>
  );
};

export default DefaultStytchLogin;
